module.exports = __webpack_public_path__ + "static/media/surveymonkey-logo.66ae66d3.png";